// extracted by mini-css-extract-plugin
module.exports = {"accent":"richComponents_accent__v6U1h"};